module.exports = __webpack_public_path__ + "e6ebfd2b893c5a5c38977acea0cb9992.svg";